export const TID = {
  // Nav
  navLogo: "nav-logo",
  navHome: "nav-home",
  navAbout: "nav-about",
  navServices: "nav-services",
  navContact: "nav-contact",
  navBlog: "nav-blog",
  navCallBtn: "nav-call-btn",
  navMobileToggle: "nav-mobile-toggle",

  // Hero
  heroCallBtn: "hero-call-btn",
  heroServicesBtn: "hero-services-btn",
  heroBookBtn: "hero-book-btn",
  heroApplianceOption: (slug) => `hero-appliance-${slug}`,

  // Sections
  sectionServices: "section-services",
  serviceCard: (slug) => `service-card-${slug}`,
  whyChooseUs: "section-why-us",
  serviceAreasSection: "section-service-areas",
  areaSlot: (slug) => `area-slot-${slug}`,
  confirmAreaBtn: "confirm-area-btn",
  ctaCallBtn: "cta-call-btn",
  ctaBookBtn: "cta-book-btn",

  // FAQ
  faqItem: (i) => `faq-item-${i}`,

  // Contact
  contactForm: "contact-form",
  contactName: "contact-name",
  contactEmail: "contact-email",
  contactPhone: "contact-phone",
  contactAppliance: "contact-appliance",
  contactMessage: "contact-message",
  contactSubmit: "contact-submit",

  // Footer
  footerCall: "footer-call",
  footerEmail: "footer-email",

  // Blog
  blogCard: (slug) => `blog-card-${slug}`,
};
